/**
 * 🔧 CAPABILITIES DATA CLIENT
 *
 * Type-safe capability/provider operations following Convex best practices.
 */
import { api } from "@convex/_generated/api";
import { BaseDataClient } from "./baseClient";
/**
 * Capabilities-specific data client
 */
export class CapabilitiesClient extends BaseDataClient {
    /**
     * List providers for user
     */
    async listProvidersForUser(userId) {
        return await this.client.query(api.capabilities.listProvidersForUser, { userId });
    }
    /**
     * Get capability catalog
     */
    async getCapabilityCatalog() {
        return await this.client.query(api.capabilities.capabilityCatalog, {});
    }
    /**
     * List running executions for user
     */
    async listRunningForUser(userId) {
        return await this.client.query(api.capabilities.listRunningForUser, { userId });
    }
    /**
     * Execute capability for provider
     */
    async executeCapabilityForProvider(params) {
        return await this.client.action(api.capabilities.executeCapabilityForProvider, params);
    }
    /**
     * Get connection for user provider
     */
    async getConnectionForUserProvider(userId, provider) {
        return await this.client.query(api.capabilities.getConnectionForUserProvider, {
            userId,
            provider
        });
    }
}
/**
 * Factory function to create a CapabilitiesClient
 */
export function createCapabilitiesClient(client) {
    return new CapabilitiesClient(client);
}
